// extracted by mini-css-extract-plugin
module.exports = {"items":"menu-items_items___mb77","item":"menu-items_item__n5d53","title":"menu-items_title___hifn","icon":"menu-items_icon___hCm3"};